import { AppState } from '../reducers/root.reducer';

export const productSelector = (state: AppState) => state.productsData;
